export const interestsList = [
	'golf',
	'handball',
	'football',
	'classicalMusic',
	'popRock',
	'cultureAndArts',
	'economyAndFinance',
	'cycling',
	'outdoor'
];

type SelectedInterests = Record<string, boolean> & {
	allowStoring: boolean;
};

export const SELECTED = interestsList.reduce(
	(map: SelectedInterests, key) => {
		map[key] = false;
		return map;
	},
	{ allowStoring: false } as SelectedInterests
);
